import React, { useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import {
  Box,
  Typography,
  Container,
  Grid,
  useTheme,
  IconButton,
  Divider,
  Stack,
  useMediaQuery,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import Footer from "../../common/Footer";
import { ColorModeContext, tokens } from "../../../theme";
import { useAppDispatch } from "../../../redux/slice/redux-hooks";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Cancel,
  CloudDownload,
  DarkModeOutlined,
  Download,
  DriveFileRenameOutline,
  LightModeOutlined,
  Preview,
  VisibilityOutlined,
} from "@mui/icons-material";
import Card from "../../common/Card";
import Button from "../../common/Button";
import { downloadDocumentById, useValidateManufacturerCredentials, validateEmailLink } from "../../../redux/slice/manufacturerNotifications/ManufacturerNotificationSlice";
import { useAuthSlice } from "../../../redux/slice/authSlice";
import { SearchIVRListRequest } from "../../../redux/slice/ivr/createIVRSlice";
import { fetchOrderDocumentsByIds, previewPrescriptionPDF, SearchOrder } from "../../../redux/slice/order/OrderSlice";
import { decryptAES } from "../../../utils/EncryptorUtils";
import { useNavigation } from "../../../hooks/useNavigation";
import { fetchIVRDocuments, useIVRDocumentSlice } from "../../../redux/slice/ivr/ivrDocumentSlice";
import JSZip from "jszip";
import saveAs from "file-saver";
import { fetchDocumentById } from "../../../redux/slice/practiceSlice";
import { CodeTable, getCodeTableValuesByTableName, useCodetablesSlice } from "../../../redux/slice/codetableSlice";
import { downloadBase64File, updateTokenToCookie } from "../../../utils/Utility";
import { Column, fetchDocumentByIdCommonApiPublic, setSingleAlertObj } from "../../../redux/slice/commonSlice";
import CustomIconButton from "../../common/CustomIconButton";
import PDFViewer from "../../common/pdf/PDFViewer";
import { useBranding } from "../../../BrandingContext";
import ManufacturerNotificationIVRDownload from "../manufacturerNotification/ManufacturerNotificationIVRDownload";
import ProviderNotificationSign from "./ProviderNotificationSign";
import SignaturePad from "../../common/signature/SignaturePad";
import CustomTable from "../../common/CustomTable";
import SigantureSubmitPopup from "../orders/SignatureSubmitPopup";
import {  saveProviderSignAgainstOrder, useProviderNotificationData } from "../../../redux/slice/providerNotifications/ProviderNotificationSlice";
import { SUCCESS_CODE } from "../../../service/ServiceConstants";
import { PRODUCT_STATUS } from "../../../constants/applicationConstants";

const ProviderNotificationAccess: React.FC = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const colorMode = React.useContext(ColorModeContext);
   const { control } = useForm<any>();
  const dispatch = useAppDispatch();
  const { navigate } = useNavigation();
  const location = useLocation();
  const { documentInfo, isLinkExpired } = useValidateManufacturerCredentials();
  const { isValidCredentials ,orderDetails } = useProviderNotificationData();
  const { allCodeTablesValuesMap, allCodeTableValueFetchStatus } = useCodetablesSlice();
  const { ivrDocumentInfoList } = useIVRDocumentSlice();
  const [showPopup, setShowPopup] = useState(false);
  const [ivrNumber, setIvrNumber] = useState("");
  const { isValid, userInfo } = useAuthSlice();
  const [email, setEmail] = useState("");
  const [ivrDocId, setIvrDocId] = useState("");
  const [ivrId, setIvrId] = useState("");
  const [orderDocId, setorderDocId] = useState("");
  const [orderNumber, setorderNumber] = useState("");
  const [orderId, setorderId] = useState("");
  const [tissueTrackingDocId, setTissueTrackingDocId] = useState("");
  const [productReturnDocId, setProductReturnDocId] = useState("");
  const [validateToken, setValidateToken] = useState("");
  const [fileName, setFileName] = useState("");
  const [documentTypes, setDocumentTypes] = useState<CodeTable[]>([]);
  const [showPDF, setShowPDF] = useState<{isShow: boolean; content: string; fileName: string;}>({ isShow: false, content: "", fileName: "" });
  const branding = useBranding();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const [showSignatureSubmitPopup, setShowSignatureSubmitPopup] = useState<boolean>(false);
  //  const [showSuccessPopup, setShowSuccessPopup] = useState<{message:string, show: boolean, title: string}>({message: "", show: false, title: "" });
  const [signatureSigned,setSignatureSigned] = useState<boolean>(false);
  const ITEMS_PER_PAGE = 20;

   const orderColumns: Column[] = [
      { id: "products", label: "Product(S)", minWidth: 100 },
    ];

  useEffect(() => {
    // Parse the URL parameters
    const params = new URLSearchParams(location.search);
    const encryptedIvrNumber = params.get('ivrNumber') || null;
    const encryptedIvrDocId = params.get('ivrDocId') || null;
    const encryptedIvrId = params.get('ivrId') || null;
    const encryptedOrderDocId = params.get('orderDocId') || null;
    const encryptedOrderNumber = params.get('orderNumber') || null;
    const encryptedOrderId = params.get('orderId') || null;
    const encryptedTissueTrackingDocId = params.get('tissueTrackingDocId') || null;
    const encryptedProductReturnDocId = params.get('productReturnDocId') || null;
    const encryptedEmail = params.get('email') || null;
    const iv = params.get('iv');
    const salt = params.get('salt');
    setValidateToken(params.get('token') || "")

    // Decrypt the parameters only if both are non-null and non-empty
    if (encryptedIvrNumber != null && encryptedIvrNumber !== '') {
      setIvrNumber(decryptAES(encryptedIvrNumber, iv, salt));
    }
    if (encryptedIvrDocId != null && encryptedIvrDocId !== '') {
      setIvrDocId(decryptAES(encryptedIvrDocId, iv, salt));
    }
    if (encryptedIvrId != null && encryptedIvrId !== '') {
      setIvrId(decryptAES(encryptedIvrId, iv, salt));
    }
    if (encryptedOrderDocId != null && encryptedOrderDocId !== '') {
      setorderDocId(decryptAES(encryptedOrderDocId, iv, salt));
    }
    if (encryptedOrderId != null && encryptedOrderId !== '') {
      setorderId(decryptAES(encryptedOrderId, iv, salt));
    }
    if (encryptedOrderNumber != null && encryptedOrderNumber !== '') {
      setorderNumber(decryptAES(encryptedOrderNumber, iv, salt));
    }
    if (encryptedTissueTrackingDocId != null && encryptedTissueTrackingDocId !== '') {
      setTissueTrackingDocId(decryptAES(encryptedTissueTrackingDocId, iv, salt));
    }
    if (encryptedProductReturnDocId != null && encryptedProductReturnDocId !== '') {
      setProductReturnDocId(decryptAES(encryptedProductReturnDocId, iv, salt));
    }
    if (encryptedEmail != null && encryptedEmail !== '') {
      setEmail(decryptAES(encryptedEmail, iv, salt));
    }
  }, [location.search]);

  useEffect(() => {
    const validateAndNavigate = async () => {
      const res = await dispatch(validateEmailLink(validateToken));
    };
    if (validateToken !== null && validateToken !== "") {
      validateAndNavigate();
    }
  }, [validateToken]);

  useEffect(() => {
    if (isLinkExpired) {
      navigate("/signIn");
    }
  }, [isLinkExpired])

  useEffect(() => {
    let searchCriteriaOrder: SearchOrder = {
      practiceIds: [],
      manufacturerIds: [],
      // CS-905
      patientFirstName: "",
      patientLastName: "",
      //
      productIds: [],
      providerName: "",
      orderNumber: orderNumber,
      invoiceNumber: "",
      serialNumber: "",
      fromDate: "",
      toDate: "",
      status: [],
      invoiceStatus: [],
      currentPage: 1,
      itemsPerPage: ITEMS_PER_PAGE,
      downloadState: false,
      fromServiceDate: '',
      toServiceDate: ''
    };
    let searchCriteriaIvr: SearchIVRListRequest = {
      productId: [],
      practiceId: [],
      productCategory: [],
      // CS-905
      patientFirstName: '',
      patientLastName: '',
      //
      verificationStatus: [],
      ivrNumber: ivrNumber,
      fromDate: "",
      toDate: "",
      currentPage: 1,
      itemsPerPage: ITEMS_PER_PAGE
    };
    if (isValid && userInfo.userName === email && ivrDocId != "" && ivrNumber != "") {
      navigate("/ivr_list", { state: { ivrDocId: ivrDocId, ivrNumber: ivrNumber, ivrListSearchCriteria: searchCriteriaIvr } })
    } else if (isValid && userInfo.userName === email && orderDocId != "" && orderNumber != "") {
      navigate("/order_list", { state: { orderDocId: orderDocId, orderNumber: orderNumber, orderListSearchCriteria: searchCriteriaOrder } });
    } else if (isValid && userInfo.userName === email && tissueTrackingDocId != "" && orderNumber != "") {
      navigate("/order_list", { state: { tissueTrackingDocId: tissueTrackingDocId, orderNumber: orderNumber, orderListSearchCriteria: searchCriteriaOrder } });
    } else if (isValid && userInfo.userName === email && productReturnDocId != "" && orderNumber != "") {
      navigate("/order_list", { state: { productReturnDocId: productReturnDocId, orderNumber: orderNumber, orderListSearchCriteria: searchCriteriaOrder } });
    } else {
      setShowPopup(true);
    }
  }, [isValid, ivrDocId, ivrNumber, orderDocId, orderNumber]);

  useEffect(() => {
    if (ivrDocId) {
      setFileName("IVR.pdf");
      if(ivrId) {
        dispatch(fetchIVRDocuments({ ivrId: ivrId, patientId: null }));
      }
    } else if (orderDocId) {
      setFileName("Order.pdf");
    } else if (tissueTrackingDocId) {
      setFileName("Tissue Tracking.pdf");
    } else if (productReturnDocId)
      setFileName("Product Return.pdf");
  }, [ivrDocId, orderDocId, tissueTrackingDocId, productReturnDocId]);

  const orderGraftRows: any[] = useMemo(() => {
      const rows: any[] = [];
      orderDetails?.orderItems.map((item: any, index: any) => {
        const row = {
          products: `${item.productItemDescription} (${item.quantity})`,
        };
        rows.push(row);
      });
      return rows;
    }, [orderDetails?.orderItems]);
           
    useEffect(()=>{
      if(orderDetails && orderDetails?.orderItems?.length > 0){
        const checkOrderItemsStatus = orderDetails.orderItems.some((item: any) => 
          item.orderStatus === PRODUCT_STATUS.PLACED
      )
      setSignatureSigned(checkOrderItemsStatus);
      }
    },[orderDetails])
  const handleClosePopup = () => {
    setShowPopup(false);
  };

  const handleActionDownload = async (docId: number) => {
    if (docId) {
      const actionResult = await dispatch(fetchDocumentByIdCommonApiPublic(docId));
      const documentData = actionResult.payload;
      if (documentData?.content) {
        downloadBase64File(documentData.content, documentData.documentName, documentData.fileType);
      } else {
        dispatch(setSingleAlertObj({ message: "Document not found!", alertType: "info" }));
      }
    }
  };

  useEffect(() => {
    if (allCodeTableValueFetchStatus === "success" && allCodeTablesValuesMap) {
      const sortedDocumentTypes = [
        ...getCodeTableValuesByTableName(allCodeTablesValuesMap, "documentType"),
      ].sort((a, b) => a.displayValue.localeCompare(b.displayValue));
      setDocumentTypes(sortedDocumentTypes);
    }
  }, [allCodeTablesValuesMap, allCodeTableValueFetchStatus]);

  // useEffect(()=>{
  //   console.log("%c Line:268 🍯 orderId", "color:#b03734", orderId);
  //   if(isValidCredentials && orderId){
  //   dispatch(getOrderDetailsForProvider(orderId))
  //   }
  // },[isValidCredentials , orderId])

  const handleSignatureData = (data: any) => {
    const payload = {
      orderId : orderId,
      providerId : orderDetails?.providerId,
      providerName :data?.providerInformation?.name,
      signature:data?.providerInformation?.signature,
      productId: orderDetails?.orderItems?.[0].productId || "",
    }
    dispatch(saveProviderSignAgainstOrder(payload)).then((response) => {
      if (response.payload && response.payload?.code === SUCCESS_CODE) {
        dispatch(
          setSingleAlertObj({
            alertType: "success",
            message: `Order (${orderNumber}) signed and placed successfully.`,//Success message changes`,
          })
        )
        setSignatureSigned(true);
      }
    }).catch((error) => {
      dispatch(
          setSingleAlertObj({
            alertType: "error",
            message: "Something went wrong while signing the order!",
            // showButton: true,
            // buttonText: "OK",
            // onButtonClick: () => { },
          })
        )
    });
  };
  // const commonDownloadComponent = (file?: string, docId?: number) => {
  //   return (
  //     <>
  //     <Box
  //       sx={{
  //         display: "flex",
  //         alignItems: "center",
  //         justifyContent: "space-between",
  //         padding: "5px",
  //         backgroundColor: colors.grey[900],
  //         borderRadius: "8px",
  //       }}
  //     >
  //       <Box
  //         sx={{
  //           display: "flex",
  //           alignItems: "center",
  //           justifyContent: "center",
  //           padding: 1.5,
  //           borderRadius: 2,
  //           borderStyle: "dotted",
  //           borderColor: colors.grey[600],
  //           m: 1,
  //         }}
  //       >
  //         <img
  //           src={require("../../../assets/download_main.png")}
  //           alt="IVR PDF"
  //           style={{ width: 40 }}
  //         />
  //       </Box>

  //       <Box>
  //         <Typography variant="h5" fontWeight="bold">
  //           {file}
  //         </Typography>
  //         <Typography variant="subtitle2" sx={{ color: colors.grey[500] }}>
  //           Click the button on the right to download your PDF
  //         </Typography>
  //       </Box>
  //         <Box sx={{ padding: "0.5rem 2rem" }}>
  //           <Typography color={colors.grey[500]} sx={{mb:0.5, ml:0.5}}>
  //             Action
  //           </Typography>
  //           <CustomIconButton
  //             color="info"
  //             size="small"
  //             variant="outlined"
  //             onClick={() => docId && handleActionDownload(docId)}
  //             tooltipMessage="Download"
  //             tooltipPlacement="bottom"
  //           >
  //             <Download />
  //           </CustomIconButton>
  //           <CustomIconButton
  //             color="info"
  //             size="small"
  //             variant="outlined"
  //             onClick={() => docId && handleActionPreview(docId)}
  //             tooltipMessage="Preview"
  //             tooltipPlacement="bottom"
  //           >
  //             <Preview />
  //           </CustomIconButton>
  //         </Box>
  //       </Box>
  //       {/* {ivrDocId && file === "Completed IVR"
  //        && !(ivrDocumentInfoList && ivrDocumentInfoList.length === 1 && ivrDocumentInfoList[0].documentType === "COMPLETED_IVR") &&
  //         <Box
  //           sx={{
  //             display: "flex",
  //             alignItems: "center",
  //             justifyContent: "space-between",
  //             backgroundColor: colors.grey[900]
  //           }}
  //         >
  //           <Typography
  //             variant="h4"
  //             fontWeight="bold"
  //             sx={{ display: "flex", alignItems: "center", ml:1 }}
  //           >
  //             Supporting Documents
  //           </Typography>
  //         </Box>} */}
  //     </>
  //   )
  // };

    // const handleActionPreview = async (documentId: number) => {
    //   if (documentId) {
    //  const actionResult = await dispatch(fetchOrderDocumentsByIds([documentId]));
    //     const documentData = actionResult.payload;
    //     if (documentData && documentData.content) {
    //       setShowPDF({
    //         isShow: true,
    //         content: documentData.content,
    //         fileName: documentData.documentName,
    //       });
    //     } else {
    //       dispatch(
    //         setSingleAlertObj({
    //           message: "Requested Document has not found under server location!",
    //           alertType: "info",
    //         })
    //       );
    //     }
    //   }
    // };

  // const downloadAll = async () => {
  //   const dataSource = ivrDocumentInfoList;
  //   if (!dataSource) return;

  //   const zip = new JSZip();
  //   const documentsFolder = zip.folder("documents");
  //   if (!documentsFolder) {
  //     console.error("Failed to create documents folder in the zip archive.");
  //     return;
  //   }
  //   for (const row of dataSource) {
  //     if (row.documentId) {
  //       await downloadAndAddToZip(row.documentId, documentsFolder);
  //     }
  //   }
  //   zip.generateAsync({ type: "blob" }).then((content) => {
  //     saveAs(content, "all_documents.zip");
  //   });
  // };

  // const downloadAndAddToZip = async (documentId: number, zipFolder: JSZip) => {
  //   const actionResult = await dispatch(
  //     fetchDocumentByIdCommonApiPublic(documentId)
  //   );
  //   const documentData = actionResult.payload;
  //   if (documentData && documentData.content) {
  //     const byteCharacters = atob(documentData.content);
  //     const byteNumbers = new Array(byteCharacters.length);
  //     for (let i = 0; i < byteCharacters.length; i++) {
  //       byteNumbers[i] = byteCharacters.charCodeAt(i);
  //     }
  //     const byteArray = new Uint8Array(byteNumbers);

  //     zipFolder.file(documentData.documentName, byteArray, { binary: true });
  //   } else {
  //     console.log(`Document with ID ${documentId} not found or is empty.`);
  //   }
  // };

  const hasLongContentList = ivrDocumentInfoList && ivrDocumentInfoList.length > 3;

//   const mainContent = () => {
//     return (
//       <Container
//         component="main"
//         maxWidth="xl"
//       >
//         <Grid
//           container
//           spacing={2}
//           justifyContent="center"
//           // alignItems="flex-start"
//         >
//           <Grid item md={6} xs={12}>
//             <Box
//               sx={{
//                 padding: "2rem",
//                 border: "1px solid",
//                 borderColor: colors.grey[600],
//                 borderRadius: "12px",
//                 backgroundColor: colors.grey[800],
//               }}
//             >
//               <Typography
//                 variant="h4"
//                 fontWeight="bold"
//                 sx={{ display: "flex", alignItems: "center", mb: 1 }}
//               >
//                 <img
//                   src={require("../../../assets/document_icon.png")}
//                   alt="Excel Icon"
//                   style={{ width: 35, height: 35, marginRight: "0.5rem" }}
//                 />
//                 Sign Order (O2025062001){orderDocId ? ` (${orderNumber})` : ""}
//               </Typography>

//               <Box display="flex" justifyContent="space-between" mb={2}>
//                 <Typography variant="h6" fontWeight="bold">
//                   <Box component="span" sx={{ color: colors.success[300] }}>
//                     Patient:
//                   </Box>{" "}
//                   Test
//                 </Typography>
//                 <Typography variant="h6" fontWeight="bold">
//                   <Box component="span" sx={{ color: colors.success[300] }}>
//                     Practice:
//                   </Box>{" "}
//                   Fondren Orthopaedic
//                 </Typography>
//               </Box>
//               <Divider sx={{ mt: 1, mb: 1 }} />
//               <Typography variant="body1" sx={{ marginBottom: "1rem" }}>
//                 Please review the order details before signing.
//                 Click 'Preview' to view the order, or 'Sign' to complete and submit your signature.
//               </Typography>
//               <Grid item xs={12} >
//                 <Box>
//                   <CustomTable
//                     columns={orderColumns}
//                     rows={orderGraftRows}
//                     disablePagination
//                     borderBox
//                     showMenu
//                     uniqueValue="Billing"
//                   />
//                 </Box>
//               </Grid>
            
// {/* 
//               <SignaturePad
//                 // isError={errorIdentifiers?.includes("signature")}
//                 onSignatureChange={() => { }}
//                 name={"testSignature"}
//                 textName={"testSignature"}
//                 control={control}
//               // validationRules={signaturePadValidations}
//               // setSignOutside={
//               //   userInfo &&
//               //   fullName(
//               //     null,
//               //     userInfo.firstName,
//               //     userInfo.middleName,
//               //     userInfo.lastName
//               //   )
//               // }
//               /> */}
//               {/* {(orderDocId || tissueTrackingDocId || productReturnDocId) &&
//                 commonDownloadComponent(fileName, parseInt(orderDocId || tissueTrackingDocId || productReturnDocId))
//               }
//               {ivrDocId && ivrDocumentInfoList?.map(info => {
//                 const filteredDocumentType =
//                   documentTypes?.find((type) => type.keyName === info.documentType)?.displayValue || info.documentType;
//                 return (
//                   commonDownloadComponent(filteredDocumentType, info.documentId)
//                 )
//               })}
//               {
//                 ivrDocId 
//                 && !(ivrDocumentInfoList && ivrDocumentInfoList.length === 1 && ivrDocumentInfoList[0].documentType === "COMPLETED_IVR") &&
//                 <Box
//                   sx={{
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "flex-end",
//                     padding: "1rem",
//                     backgroundColor: colors.grey[900],
//                     borderRadius: "8px",
//                   }}
//                 >
//                   <Button
//                     variant="outlined"
//                     startIcon={<Download />}
//                     color="info"
//                     sx={{ padding: "0.5rem 2rem" }}
//                     onClick={() => downloadAll()}
//                   >
//                     Download All
//                   </Button>
//                 </Box>
//               } */}
//                    <Grid item xs={12}>
//               <Box
//                   sx={{
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                     backgroundColor: colors.grey[900],
//                     borderRadius: "8px",
//                   }}
//                 >
//                   <Button
//                     variant="outlined"
//                     startIcon={<Download />}
//                     color="info"
//                     // onClick={() => downloadAll()}
//                   >
//                     Sign Order
//                   </Button>
//                 </Box>
//           </Grid>
//             </Box>
//           </Grid>
     
//           {/* <Grid item md={6} xs={12}>
//             <React.Fragment>
//               <Stack
//                 direction={{ xs: "column", sm: "row" }}
//                 justifyContent="flex-end"
//                 spacing={2}
//               >
//                 <Grid item xs={12}>
//                   <Button
//                     fullWidth
//                     startIcon={<VisibilityOutlined />}
//                     color="info"
//                     // onClick={onPreviewClick}
//                   >
//                     Preview
//                   </Button>
//                 </Grid>
//                 <Grid item xs={12}>
//                   <Button
//                     fullWidth
//                     type="submit"
//                     startIcon={<DriveFileRenameOutline />}
//                     data-allow-submit="true"
//                   >
//                     Sign
//                   </Button>
//                 </Grid>
//                 <Grid item xs={12}>
//                   <Button fullWidth startIcon={<Cancel />} color="error"
//                     // onClick={cancelBAASigning} 
//                     >

//                     Cancel
//                   </Button>
//                 </Grid>
//               </Stack>
//             </React.Fragment>
//           </Grid> */}
//         </Grid>
//       </Container>
//     )
//   };
 const handlePrescriptionPrview = async (orderId:string) => {
    const actionResult = await dispatch(previewPrescriptionPDF(parseInt(orderId)));
    const documentData = actionResult.payload;
    if (documentData && documentData.content) {
      setShowPDF({
        isShow: true,
        content: documentData.content,
        fileName: orderNumber+"_Prescription",
      });
    }
  };
  return (
    <>
      <Box display="flex" flexDirection="column" minHeight="100vh">
        {/* Header */}
        <Box
          component="header"
          sx={{
            backgroundColor: colors.grey[800],
            borderBottom: `1px solid ${colors.grey[700]}`,
            zIndex: 10,
            p: 1,
          }}
        >
          <Grid container alignItems="center">
            <Grid item xs={4}></Grid>
            <Grid item xs={4} textAlign="center">
              <img
                alt="logo"
                src={
                  theme.palette.mode === "dark"
                    ? branding?.logoWhite
                    : branding?.logo || require("../../../branding-assets/v3biomed/logo.png")
                }
                style={{ height: "60px", objectFit: "contain", maxWidth: "100%" }}
              />
            </Grid>
            <Grid item xs={4} textAlign="end">
              <IconButton onClick={colorMode.toggleColorMode}>
                {theme.palette.mode === "dark" ? <LightModeOutlined /> : <DarkModeOutlined />}
              </IconButton>
            </Grid>
          </Grid>
        </Box>

        {/* Main content full width and centered */}
        <Box
          component="main"
          flexGrow={1}
          display="flex"
          justifyContent="center"
          alignItems="center"
          px={{ xs: 1, sm: 3, md: 6 }}
          py={2}
        >
          <Box
            sx={{
              border: "1px solid",
              borderColor: colors.grey[600],
              borderRadius: "12px",
              backgroundColor: colors.grey[800],
              p: 3,
              mb: 4, // 👈 Add this to give spacing above the footer
            }}
          >
            <Typography
              variant="h5"
              fontWeight="bold"
              sx={{ display: "flex", alignItems: "center", mb: 2 }}
            >
              <img
                src={require("../../../assets/document_icon.png")}
                alt="Doc Icon"
                style={{ width: 35, height: 35, marginRight: "0.5rem" }}
              />
              {/* Sign Order ({orderNumber}) */}
              {signatureSigned ? `Order (${orderNumber}) Signed` : `Sign Order (${orderNumber})`}
            </Typography>

            <Box display="flex" justifyContent="space-between" mb={2}>
              <Typography variant="h6" fontWeight="bold">
                <Box component="span" sx={{ color: colors.success[300] }}>Patient:</Box> {orderDetails?.patientName || "-"}
              </Typography>
              <Typography variant="h6" fontWeight="bold">
                <Box component="span" sx={{ color: colors.success[300] }}>Practice:</Box> {orderDetails?.practiceName || "-"}
              </Typography>
            </Box>

            <Divider sx={{ mb: 2 }} />

            <Typography variant="body2" mb={2}>
              Please review the order details before signing. Click 'Preview' to view the order, or 'Sign' to complete and submit your signature.
            </Typography>

            <Box mb={3}>
              <CustomTable
                columns={orderColumns}
                rows={orderGraftRows}
                disablePagination
                borderBox
                showMenu
                uniqueValue="Billing"
              />
            </Box>

            <Box display="flex" justifyContent="space-evenly">
              <Button
                variant="contained"
                startIcon={<VisibilityOutlined />}
                color="info"
                onClick={() => {
                  handlePrescriptionPrview(orderId);
                }}
              >
                Preview
              </Button>
              {!signatureSigned && (
              <Button
                variant="contained"
                startIcon={<DriveFileRenameOutline />}
                color="success"
                onClick={() => setShowSignatureSubmitPopup(true)}
              >
               Sign Order
              </Button>
              )}
            </Box>
          </Box>
        </Box>

        {/* Footer */}
        <Box component="footer">
          <Footer />
        </Box>
      </Box>

      {/* Popups */}
      {showPopup && <ProviderNotificationSign onClose={handleClosePopup} />}
      {showPDF && (
        <PDFViewer
          isOpen={showPDF.isShow}
          onClose={() => setShowPDF({ isShow: false, content: "", fileName: "" })}
          title={showPDF.fileName}
          fileName={showPDF.fileName}
          base64String={showPDF.content || ""}
        />
      )}
      {showSignatureSubmitPopup && <SigantureSubmitPopup
        open={showSignatureSubmitPopup}
        onClose={() => { setShowSignatureSubmitPopup(false); }}
        addProductItem={() => { }}
        productItemDetails={{}}
        isEdit={false}
        practiceName={orderDetails?.practiceName}
        selectedProviderData={[{ providerName: orderDetails?.providerName ,npi:"",ptan:"",taxId:""}]}
         addSignature={handleSignatureData}
         authorizedSigner={false}
      />}
    </>
  );
};

export default ProviderNotificationAccess;